// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"e62b61e2","392":"34aa26ad","425":"5eb8c7b4","453":"dc3e3b20","455":"b20e1d82","582":"fcc1e8bb","683":"b1da4217","720":"ad0c6428","758":"1aa02eef","847":"5bfa2b63","977":"70e5a355"}[chunkId] + ".chunk.js";
};